import store from "../../../common/store/Store";

function SetLeadMaxLengthAndValue(obj: any, value: any, entityType: string, fieldType: string) {
  const state = store.getState();
  const model = state.models[fieldType]?.[entityType];
  const length = model?.find((m: any) => m.value === value)?.length;

  if (!value) {
    obj.setPropertyValue("leadMap", null);
    obj.setPropertyValue("crmLeadMaxLength", null);
    obj.setPropertyValue("crmMaxLength", null);
  }
  if (length && value) {
    obj.setPropertyValue("crmLeadMaxLength", length);
    obj.setPropertyValue("leadMap", value);
    if (
      !obj.getPropertyValue("crmContactMaxLength") ||
      obj.getPropertyValue("crmContactMaxLength") === 1 ||
      obj.getPropertyValue("crmContactMaxLength") > length ||
      obj.getPropertyValue("crmLeadMaxLength") < length
    ) {
      obj.setPropertyValue("crmMaxLength", length);
    } else {
      obj.setPropertyValue("crmMaxLength", obj.getPropertyValue("crmContactMaxLength"));
    }
  }
  if (!length && value) {
    obj.setPropertyValue("leadMap", value);
  }
}

export default SetLeadMaxLengthAndValue;
